import { Optional, defined, setDefault } from '../utils/Util';

const COMPONENT_KIND = {
  choices: ['race_category', 'race_kind'] as string[],
  toggles: ['sgt', 'sf'] as string[], // FIXME
  options: ['tyre', 'circuit', 'manufacturer', 'car_name'] as string[], // car_nameはSF用
} as const;

export interface Table {
  tableId: string;
  requiredChoiceOptions: Record<string, Set<Optional<string>>>;
  requiredToggleOptions: Record<string, string>;
  optionalOptions: Record<string, Set<string>>;
  data: Record<string, string>[];
} // テーブルの部品の種類を決めるための定数

export const createOptions = (paths: string[]): Table[] => {
  const data: { [name: string]: { [name: string]: string }[] } = {};
  for (const path of paths) {
    const [title, map] = parseTableName(path);
    setDefault(data, title, []).push(map);
  }

  const result: Table[] = [];
  for (const [tableId, maps] of Object.entries(data)) {
    const options: Record<string, Set<string>> = {};
    for (const map of maps) {
      for (const [key, value] of Object.entries(map)) {
        setDefault(options, key, new Set<string>()).add(value);
      }
    }
    const requiredChoiceOptions: Record<string, Set<Optional<string>>> = {};
    const requiredToggleOptions: Record<string, string> = {};
    const optionalOptions: Record<string, Set<string>> = {};

    for (const [name, values] of Object.entries(options)) {
      if (COMPONENT_KIND.choices.includes(name)) {
        let v: Set<Optional<string>> = values;
        if (!maps.every((map) => defined(map[name]))) {
          v = new Set<Optional<string>>(values).add(undefined);
        }
        requiredChoiceOptions[name] = v;
      } else if (COMPONENT_KIND.toggles.includes(name)) {
        const v = Array.from(values)[0];
        if (defined(v)) {
          requiredToggleOptions[name] = v;
        }
      } else if (COMPONENT_KIND.options.includes(name)) {
        optionalOptions[name] = values;
      } else {
        throw new Error(name);
      }
    }
    result.push({
      tableId,
      requiredChoiceOptions,
      requiredToggleOptions,
      optionalOptions,
      data: maps,
    });
  }
  return result;
};

export const createTableName = (
  tableId: string,
  map: Record<string, string>
): string => {
  const { keys, values } = Object.entries(map).reduce(
    ({ keys, values }, [key, value]) => {
      if (defined(value)) {
        return { keys: [...keys, key], values: [...values, value] };
      } else {
        return { keys, values };
      }
    },
    { keys: [], values: [] } as { keys: string[]; values: string[] }
  );
  const parts = [tableId];
  parts.push(...keys, ...values);
  return parts.join('-');
};

export const parseTableName = (
  path: string
): [string, Record<string, string>] => {
  const parts = path.split('-');
  const title = parts.splice(0, 2 - (parts.length % 2)).join('-');
  const map: Record<string, string> = {};
  const halfLength = parts.length / 2;
  for (let i = 0; i < halfLength; i++) {
    const key = parts[i];
    const value = parts[halfLength + i];
    if (defined(key) && defined(value)) {
      map[key] = value;
    }
  }
  return [title, map];
};
